<template>
  <el-dialog
    :title="$t('deletePrivilegeGroup.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    :close-on-click-modal="false">
    <div class="modal-body">
      <p>{{ $t('deletePrivilegeGroup.deleteWarning') }} {{ deletePrivilegeGroupInfo.name }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('deletePrivilegeGroup.cancel') }}</el-button>
      <el-button 
        type="danger" 
        @click="deletePrivilegeGroup"
        :loading="loading">
        {{ $t('deletePrivilegeGroup.confirmDelete') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deletePrivilegeGroup } from '@/api/privilege/privilegeApi'

export default {
  name: 'DeletePrivilegeGroup',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      deletePrivilegeGroupInfo: {}
    }
  },
  methods: {
    open(pGroup) {
      this.deletePrivilegeGroupInfo = pGroup
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async deletePrivilegeGroup() {
      try {
        this.loading = true
        const res = await deletePrivilegeGroup(this.deletePrivilegeGroupInfo)
        if (res.code === 0) {
          this.$message.success(this.$t('deletePrivilegeGroup.deleteSuccess'))
          this.dialogVisible = false
          this.$emit('privilegeGroup_loadPrivilegeGroup')
          this.$emit('roleDiv_loadRole')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('Failed to delete privilege group:', error)
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.modal-body {
  text-align: center;
  font-size: 16px;
  padding: 20px 0;
}
</style>